
import { uniqueId } from 'lodash'
import { useCallback, useEffect, useMemo, useState } from "react"
import { useMatch, useNavigate } from "react-router"
import { MdKeyboardArrowDown } from "react-icons/md"
import { SidenavItemProps } from '../Korbantech'

const SidenavItemOsc = ( { icon: Icon,img, to, bg_color, whenActive, isChildren,textColor,hoverText ,hoverColor,...props }:SidenavItemProps ) => {

    const active = useMatch( to )
    const [ showSub, setShowSub ] = useState( false )

    const navigate = useNavigate( )


    const toggleSub = useCallback( () => {
        setShowSub( prev => !prev )
    }, [ ] )

    const classes = useMemo( () => {
        return "relative cursor-pointer "
            + " items-center my-px "
            + ( !isChildren ? " mr-2.5 ml-2.5 rounded " : 
            " border-dotted border-l-2 ml-10 border-black " )
            
    }, [ isChildren] )

    const goTo = useCallback( () => {
        if(!props.children) navigate( to )
        if(props.children) toggleSub();
    }, [ navigate, to,props ,toggleSub])

    useEffect( () => {
        active && whenActive && whenActive()
    }, [ whenActive, active ] )

    return (

        
        <div className={`w-full pl-1 ${classes} hover:border-dotted 
        hover:border-2 
        hover:border-black`} >
            <div
            style={{
                backgroundImage:`url('${active || showSub ? img : ""}')`,
                backgroundSize:"cover"
            }}
                className={`flex`}
                onClick={ goTo }
            > { Icon && 
                <div className="h-10 w-10  flex items-center justify-center">
                    <Icon />
                </div>
                }
                <div className="flex items-center">
                    { props.label }
                </div>
                {
                props.children && props.children.length > 0 &&
                    <div
                        onClick={ toggleSub }
                        className={ " w-10 flex items-center justify-center" }
                    >
                        <MdKeyboardArrowDown
                            className={"transform transition-all " + ( !showSub ? '' : 'rotate-180' )}
                        />
                    </div>
                }
            </div>
            <div
                className={
                    `flex flex-col ${showSub ? "" : "h-0 hidden"}`
                }
            >
                {
                    props.children &&
                        props.children.map( item => (
                            <SidenavItemOsc key={ uniqueId() } { ...item } isChildren={ true } />
                        ))
                }
            </div>
          
        </div>
    )
}

export default SidenavItemOsc
